<template>
  <div class="bard-exclusive" v-html="processedContent" />
</template>

<script setup lang="ts">
const props = defineProps<{
  content: string | undefined
  color: string
}>()

const processedContent = computed(() => {
  if (!props.content) return ''
  // Modify the <strong> tag to include the inline style for color
  return props.content.replace(
    /<strong>(.*?)<\/strong>/g,
    `<strong style="color: ${props.color}">$1</strong>`
  )
})
</script>
